<!--
     <Tag
       :props="my_attrs_dictionary"
     />

     Public propertys:
       value → undefined
       validate → true

     Accepted props:
     - label
     - class
-->

<template>
  <div
    :class="props.class"
    v-text="props.label"
  ></div>
</template>


<script>
 export default {
   name: 'Tag',

   props: ['props'],

   data: (() => ({})),

   methods: {
     validate() {
       return !!'!'; // true.  But i'm cool.
     },
   },
 }
</script>
